export default __webpack_public_path__ + "static/tag-dont-1-light-56b1d910bfb45835c2b2601eb66c01d799d5cf090f100021081c9af9f04e3a72.png";